import ReactDOM from 'react-dom/client';
import './local';
import './i18n';

import './index.scss';
import './portal.css';
import 'antd/dist/reset.css';

import App from "./App";

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

reportWebVitals();
